import { Stack, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'

import Content from 'components/common/Content'
import { Header } from 'components/navigation/Header'
import { TestSuiteForm } from 'components/test-suites/forms/TestSuiteForm'
import {
  TestSuiteFormMode,
  useTestSuiteFormContext
} from 'components/test-suites/forms/TestSuiteFormContext'
import { TestSuitesBreadcrumbs } from 'components/test-suites/TestSuitesBreadcrumbs'

export const CreateTestSuitePage: React.FC = () => {
  const { testSuiteClone, testSuiteFormMode } = useTestSuiteFormContext()

  const title =
    testSuiteFormMode === TestSuiteFormMode.Clone && testSuiteClone
      ? `Clone - ${testSuiteClone.name}`
      : 'Create a Test Suite'

  return (
    <>
      <Helmet title={title} />
      <Header>
        <TestSuitesBreadcrumbs>
          <Typography color="text.primary">{title}</Typography>
        </TestSuitesBreadcrumbs>
      </Header>
      <Content
        css={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr)',
          gridAutoRows: 'min-content'
        }}
      >
        <Stack spacing={4}>
          <TestSuiteForm />
        </Stack>
      </Content>
    </>
  )
}
